import { FormGroup } from '@angular/forms';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { isEqual } from 'lodash-es';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { formPaths } from '@shared/constants/form-paths.const';
import { toNum } from '@shared/helpers/math.helper';
import {
    MyAllElemConsiglioAmministrazioneEntity,
    MyAllElemLiquidatoriEntity,
} from '../../../../models/interfaces/revisione.interface';
import {
    getNormeSpaOrdinarioControl,
    getAmmControlloControl,
    normeSpaOrdinarioCkHelper,
    checkCkNormeValue,
} from './helpers/norme-spa-ordinario-form-validators.helper';

export const normeSpaOrdinarioTipoAmmRules: FormGroupRules = {
    my_CkSpoTipoAmministrazione: (form: FormGroup) => {
        const my_CkSpoTipoAmministrazioneControl = getNormeSpaOrdinarioControl(form, 'my_CkSpoTipoAmministrazione');
        const my_CkSpoTipoAmministrazione: string = my_CkSpoTipoAmministrazioneControl.value;
        const my_AllElemConsiglioAmministrazione: MyAllElemConsiglioAmministrazioneEntity[] = getAmmControlloControl(
            form,
            'my_AllConsiglioAmministrazione.my_AllElemConsiglioAmministrazione'
        ).value;
        const my_AllAmminUnico: string = getAmmControlloControl(form, 'my_AllAmminUnico').value;
        const my_AllElemLiquidatori: MyAllElemLiquidatoriEntity[] = getAmmControlloControl(form, 'my_AllLiquidatori.my_AllElemLiquidatori').value;
        const errors = my_CkSpoTipoAmministrazioneControl.errors ? my_CkSpoTipoAmministrazioneControl.errors : {};

        addRemoveError(checkCkNormeValue(form) && my_CkSpoTipoAmministrazione === '1' && !my_AllElemConsiglioAmministrazione?.length, errors, 'my_CkSpoTipoAmministrazione', {
            status: 'Inserire il Consiglio di Amministrazione.',
            message: "Il Consiglio di Amministrazione è obbligatorio quando è stato scelto per l'amministrazione.",
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpoTipoAmministrazione === '1' && !isNilOrEmpty(my_AllAmminUnico), errors, 'my_CkSpoTipoAmministrazione', {
            status: "Eliminare l'Amministratore Unico.",
            message: "Si è scelto il Consiglio di Amministrazione ma è presente anche l'Amministratore Unico.",
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpoTipoAmministrazione === '1' && !isNilOrEmpty(my_AllElemLiquidatori), errors, 'my_CkSpoTipoAmministrazione', {
            status: 'Eliminare i Liquidatori',
            message: 'Si è scelto Consiglio di Amministrazione come tipo di amministrazione ma sono presenti dei Liquidatori.',
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpoTipoAmministrazione === '2' && !my_AllAmminUnico?.length, errors, 'my_CkSpoTipoAmministrazione', {
            status: "Inserire l'Amministratore Unico.",
            message: "L'Amministratore Unico è obbligatorio quando è stato scelto per l'amministrazione.",
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpoTipoAmministrazione === '2' && !isNilOrEmpty(my_AllElemConsiglioAmministrazione), errors, 'my_CkSpoTipoAmministrazione', {
            status: 'Eliminare il Consiglio di Amministrazione.',
            message: "Si è scelto l'Amministratore Unico ma sono presenti persone nel Consiglio di Amministrazione.",
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpoTipoAmministrazione === '2' && !isNilOrEmpty(my_AllElemLiquidatori), errors, 'my_CkSpoTipoAmministrazione', {
            status: 'Eliminare i Liquidatori',
            message: 'Si è scelto Amministratore Unico come tipo di amministrazione ma sono presenti ancora dei Liquidatori.',
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpoTipoAmministrazione === '3' && !my_AllElemLiquidatori?.length, errors, 'my_CkSpoTipoAmministrazione', {
            status: 'Inserire i Liquidatori',
            message: 'Occorre specificare almeno un Liquidatore in quanto si è selezionato Liquidatori come tipo di amministrazione.',
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpoTipoAmministrazione === '3' && !isNilOrEmpty(my_AllElemConsiglioAmministrazione), errors, 'my_CkSpoTipoAmministrazione', {
            status: 'Eliminare il Consiglio di Amministrazione',
            message: 'Si è scelto Liquidatori come tipo di amministrazione ma sono presenti ancora componenti del Consiglio di Amministrazione.',
        });

        addRemoveError(checkCkNormeValue(form) && my_CkSpoTipoAmministrazione === '3' && !isNilOrEmpty(my_AllAmminUnico), errors, 'my_CkSpoTipoAmministrazione', {
            status: "Eliminare l'Amministratore Unico",
            message: 'Si è scelto Liquidatori come tipo di amministrazione ma è ancora presente un Amministratore Unico.',
        });

        addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_CkSpoTipoAmministrazione), errors, 'my_CkSpoTipoAmministrazione', {
            status: REQUIRED_STATUS,
        });

        my_CkSpoTipoAmministrazioneControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSpoMaggAmminSoci: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(form, 'my_NormeSpaOrdinario.my_CkSpoMaggAmminSoci', 'my_NormeSpaOrdinario.my_CkSpoTipoAmministrazione', 1);
    },

    my_CkSpoNominComitEsec: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(form, 'my_NormeSpaOrdinario.my_CkSpoNominComitEsec', 'my_NormeSpaOrdinario.my_CkSpoTipoAmministrazione', 1);
    },

    my_CkSpoAmminRelazionano: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(form, 'my_NormeSpaOrdinario.my_CkSpoAmminRelazionano', 'my_NormeSpaOrdinario.my_CkSpoTipoAmministrazione', 1);
    },

    my_CkSpoCompStatoInConsAmmin: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(form, 'my_NormeSpaOrdinario.my_CkSpoCompStatoInConsAmmin', 'my_NormeSpaOrdinario.my_CkSpoTipoAmministrazione', 1);
    },

    my_CkSpoRegistroDelib: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(form, 'my_NormeSpaOrdinario.my_CkSpoRegistroDelib', 'my_NormeSpaOrdinario.my_CkSpoTipoAmministrazione', 2);
    },

    my_SpoAttribComitEsec: (form: FormGroup) => {
        const my_CkSpoTipoAmministrazione = toNum(getNormeSpaOrdinarioControl(form, 'my_CkSpoTipoAmministrazione').value);
        normeSpaOrdinarioCkHelper(
            form,
            'my_NormeSpaOrdinario.my_SpoAttribComitEsec',
            'my_NormeSpaOrdinario.my_CkSpoNominComitEsec',
            1,
            formPaths.ammControllo,
            my_CkSpoTipoAmministrazione === 1
        );
    },

    my_SpoScadenzaAmministratori: (form: FormGroup) => {
        const my_SpoScadenzaAmministratoriControl = getNormeSpaOrdinarioControl(form, 'my_SpoScadenzaAmministratori');
        const my_SpoScadenzaAmministratori = toNum(my_SpoScadenzaAmministratoriControl.value);
        const my_CkSpoTipoAmministrazione = toNum(getNormeSpaOrdinarioControl(form, 'my_CkSpoTipoAmministrazione').value);
        const showInconsistentChoiceError =
            checkCkNormeValue(form) &&
            ((my_SpoScadenzaAmministratori === 99 && my_CkSpoTipoAmministrazione !== 3) || (my_SpoScadenzaAmministratori !== 99 && my_CkSpoTipoAmministrazione === 3));
        const errors = my_SpoScadenzaAmministratoriControl.errors ? my_SpoScadenzaAmministratoriControl.errors : {};

        addRemoveError(showInconsistentChoiceError, errors, 'my_SpoScadenzaAmministratori', {
            status: 'Selezione incoerente',
        });

        addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_SpoScadenzaAmministratori), errors, 'my_SpoScadenzaAmministratori', {
            status: REQUIRED_STATUS,
        });

        my_SpoScadenzaAmministratoriControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSpoSindaciConsAmmin: (form: FormGroup) => {
        const my_CkSpoTipoAmministrazione: string = getNormeSpaOrdinarioControl(form, 'my_CkSpoTipoAmministrazione').value;
        normeSpaOrdinarioCkHelper(
            form,
            'my_NormeSpaOrdinario.my_CkSpoSindaciConsAmmin',
            'my_NormeSpaOrdinario.my_CkSpoAssembNominSind',
            1,
            formPaths.ammControllo,
            my_CkSpoTipoAmministrazione === '1'
        );
    },

    my_SpoNoteComposConsAmmin: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(form, 'my_NormeSpaOrdinario.my_SpoNoteComposConsAmmin', 'my_NormeSpaOrdinario.my_CkSpoTipoAmministrazione', 1);
    },

    my_SpoNoteAmminUnico: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(form, 'my_NormeSpaOrdinario.my_SpoNoteAmminUnico', 'my_NormeSpaOrdinario.my_CkSpoTipoAmministrazione', 2);
    },

    my_CKSPOAmmUniRelCarMutua: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(form, 'my_NormeSpaOrdinario.my_gruppo3.my_CKSPOAmmUniRelCarMutua', 'my_NormeSpaOrdinario.my_CkSpoTipoAmministrazione', 2);
    },

    my_CkSpoCompElettiStrFinan: (form: FormGroup) => {
        normeSpaOrdinarioCkHelper(form, 'my_NormeSpaOrdinario.my_CkSpoCompElettiStrFinan', 'my_NormeSpaOrdinario.my_CkSpoTipoAmministrazione', 1);
    },

    my_CkSpoCompElettiLimite: (form: FormGroup) => {
        const my_CkSpoCompElettiStrFinan: string = getNormeSpaOrdinarioControl(form, 'my_CkSpoCompElettiStrFinan').value;
        normeSpaOrdinarioCkHelper(
            form,
            'my_NormeSpaOrdinario.my_CkSpoCompElettiLimite',
            'my_NormeSpaOrdinario.my_CkSpoTipoAmministrazione',
            1,
            formPaths.ammControllo,
            my_CkSpoCompElettiStrFinan === '1'
        );
    },
};
